// extracted by mini-css-extract-plugin
export var active = "_35-9";
export var backButton = "_35-8";
export var clone = "_35-e";
export var collapseBar = "_35-j";
export var collapseMode = "_35-l";
export var collapsed = "_35-n";
export var dragHandle = "_35-c";
export var dropdownIcon = "_35-g";
export var expanding = "_35-m";
export var hidden = "_35-w";
export var iconContainer = "_35-p";
export var iconSwapper = "_35-v";
export var navItem = "_35-6";
export var navItemIcon = "_35-f";
export var navProfile = "_35-7";
export var notificationCountBadge = "_35-i";
export var notificationDot = "_35-q";
export var optionsContainer = "_35-h";
export var primaryNav = "_35-0";
export var primaryNavDivider = "_35-u";
export var primaryNavResizeHandle = "_35-2";
export var primaryNavResizing = "_35-1";
export var primaryNavTabSection = "_35-t";
export var primaryTab = "_35-o";
export var primaryTabIconBox = "_35-r";
export var secondaryNav = "_35-3";
export var selected = "_35-s";
export var settingsNav = "_35-4";
export var settingsNavItems = "_35-5";
export var show = "_35-d";
export var sideNav = "_35-k";
export var teamItem = "_35-a";
export var userProfileItem = "_35-b";